// extracted by mini-css-extract-plugin
export default {"preview":"preview-preview-cVREEl","projects":"preview-projects-x8ajHR","projectsInner":"preview-projectsInner-QAzrZl"};